/** The different endpoint actions available for the Bill route. */
export enum BillActions {
  Actions = 'actions',
  Amendments = 'amendments',
  Committees = 'committees',
  Cosponsors = 'cosponsors',
  RelatedBills = 'relatedBills',
  Subjects = 'subjects',
  Summaries = 'summaries',
  Text = 'text',
  Titles = 'titles'
}
